import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    DELETE_PATIENT_LIST,
    deletePatientListFail,
    deletePatientListSuccess
} from '../action/deletePatientListAction'

// api 
import deletePatientListApi from '../api/deletePatientListApi'

export function* deletePatientListSaga(action) {

    try {
        const response = yield call(() => deletePatientListApi(action.params))
        console.log("sms",response.data)
        if (response.data.statusCode === 200) {
            console.log("hey",response.data)
            yield put(deletePatientListSuccess(response, action))
        } else {
            yield put(deletePatientListFail(response, action))
        }
    }
    catch (e) {
        yield put(deletePatientListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(DELETE_PATIENT_LIST, deletePatientListSaga)
}